import React from 'react'
import { Link } from 'react-router-dom'

import providesDeleteTemplateMutation from 'components/Templates/dataSync/providesDeleteTemplateMutation'

import Confirm from 'components/Utils/Modal/Confirm'
import { Text } from 'components/base'
import { DeleteIcon } from 'components/Utils/Icons'
import IconButton from 'components/Utils/IconButton'
import Icon from 'components/Templates/Icon'

import RoutesHelper from 'helpers/RoutesHelper'

import { RowLayout } from './RowLayout'

export type TemplateNoteItemProps = {
  id: string
  depth: number
  isActive: boolean
  title: string
  details: React.ReactNode
  deleteTemplate: (value: { id: string }) => void
}

const TemplateNoteItem = ({
  id,
  depth,
  isActive,
  title,
  deleteTemplate,
}: TemplateNoteItemProps) => {
  const [deletingTemplate, setDeletingTemplate] = React.useState(false)

  const onConfirmDeleteTemplate = () => {
    setDeletingTemplate(false)
    deleteTemplate({ id })
  }

  return (
    <>
      <RowLayout
        renderComponent={props => (
          <Link {...props} to={RoutesHelper.noteTemplateShow({ noteId: id })} />
        )}
        className="child-effects-on-hover"
        depth={depth}
        label={title || 'Untitled'}
        isActive={isActive}
        icon={<Icon templateId={id} />}
        rightPart={
          <IconButton
            className="display-none flexbox-child-effect"
            colorScheme="grayOnGray"
            boxSize="smaller"
            onClick={(event: React.MouseEvent) => {
              event.preventDefault()
              event.stopPropagation()
              setDeletingTemplate(true)
            }}
          >
            <DeleteIcon size="12" />
          </IconButton>
        }
      />
      <Confirm
        show={Boolean(deletingTemplate)}
        onConfirm={onConfirmDeleteTemplate}
        onCancel={() => {
          setDeletingTemplate(false)
        }}
      >
        <div>
          <Text.Subtitle>Are you sure?</Text.Subtitle>

          <Text.Corpus className="margin-vertical-large">
            You are about to permanently delete a template.
          </Text.Corpus>
        </div>
      </Confirm>
    </>
  )
}
export const EnhancedTemplateNoteItem = providesDeleteTemplateMutation(
  TemplateNoteItem
)
